const TABLET_THRESHOLD = 768;

export const shouldShowMobileNavigation = (width: number) => {
  return width <= TABLET_THRESHOLD;
};

export const getCaseStudySectionHeaderTheme = (width: number) => {
  return width <= TABLET_THRESHOLD ? 'light' : 'dark';
};
